var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.color,attrs:{"dark":""}},[_c('v-card-text',{staticClass:"text-center",staticStyle:{"height":"100px"}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('div',{staticClass:"text-h4 text-gold text-shadow"},[_vm._v(_vm._s(_vm.data))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }